export type CostCenterStatusDto =
  | string
  | {
      code?: string;
      name?: string;
      label?: string;
      value?: string;
      tone?: string;
    };

export type CostCenterTypeRef = {
  uuid: string;
  name: string;
  projectRelated: boolean;
};

export type CostCenterDevelopmentRef = {
  uuid: string;
  name: string;
};

export type CostCenterDto = {
  uuid: string;
  code: string;
  name: string;
  description: string | null;
  type?: CostCenterTypeRef | null;
  development?: CostCenterDevelopmentRef | null;
  typeUuid?: string;
  developmentUuid?: string | null;
  status: CostCenterStatusDto;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type CostCenterRequest = {
  code: string;
  name: string;
  typeUuid: string;
  developmentUuid: string | null;
  description: string | null;
};

export type CostCenterListQuery = {
  code?: string;
  name?: string;
  description?: string;
  development?: string;
  typeUuids?: string[];
  status?: string[];
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
};

export type CostCenterListResult = {
  items: CostCenterDto[];
  total: number;
};

export type CostCenterFormSelects = {
  types: CostCenterTypeRef[];
  developments: CostCenterDevelopmentRef[];
};

export type CostCenterFilterOption = {
  name: string;
  value: string;
};

export type CostCenterFilterSelects = {
  status: CostCenterFilterOption[];
  types: CostCenterFilterOption[];
};

export type CostCenterStatusLabel = 'Activo' | 'Inactivo';

export function costCenterStatusLabel(dto: CostCenterDto): CostCenterStatusLabel {
  const status = dto.status;
  if (status && typeof status === 'object') {
    if (status.tone === 'danger') return 'Inactivo';
    if (status.tone === 'success') return 'Activo';
    return classifyStatusName(status.name ?? status.label ?? status.code ?? '');
  }
  if (typeof status === 'string') {
    return classifyStatusName(status);
  }
  if (typeof dto.enabled === 'boolean') {
    return dto.enabled ? 'Activo' : 'Inactivo';
  }
  return 'Activo';
}

function classifyStatusName(raw: string): CostCenterStatusLabel {
  const normalized = raw.trim().toLowerCase();
  if (
    normalized === 'inactivo' ||
    normalized === 'inactive' ||
    normalized === 'disabled' ||
    normalized.startsWith('inactiv')
  ) {
    return 'Inactivo';
  }
  return 'Activo';
}

export function costCenterTypeProjectRelated(dto: CostCenterDto): boolean {
  return dto.type?.projectRelated === true;
}
